import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["onClick", "onMouseenter"]

import { useKeyDownStore } from '@/stores/key-down';
import { ContextMenuItem, useContextMenu } from '@/utils/hooks/context-menu';
import { computed, ref, shallowRef, watch, watchPostEffect } from 'vue';
import RightArrowIcon from './icons/navigation/RightArrowIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VContextMenu',
  props: {
    menu: null
  },
  emits: ["itemclick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'itemclick', item: ContextMenuItem): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  menu: ReturnType<typeof useContextMenu>
}

const menuRef = ref<HTMLDivElement>()


  
const menu = props.menu.menu

const hasChildren = computed(() => menu.value?.find(item => !!item.children))
const childrenContextMenu = useContextMenu((item: ContextMenuItem) => {
  if (!item.children) return []
  if (typeof item.children === "function") return item.children()
  return item.children
}, { anchorOrigin: "top right", contentOrigin: "top left", offset: { y: -8 }, closeOnLeave: false })

const onItemClick = (item: ContextMenuItem) => {
  if (!item.onClick || item.disabled) return
  item.onClick()
  emit("itemclick", item)
  props.menu.close()
}

const hoverElement = shallowRef<ContextMenuItem | null>(null)
const onItemHover = (e: MouseEvent, item: ContextMenuItem) => {
  if (!hasChildren.value) return
  if (!item.children || item.disabled) {
    hoverElement.value = null
    childrenContextMenu.close()
    return
  }
  hoverElement.value = item
  childrenContextMenu.hoverEmits.mouseenter(e, item)
}

watch(() => props.menu.props.show, (show) => {
  if (show || !hasChildren) return
  childrenContextMenu.close()
})
watchPostEffect(() => {
  if (props.menu.props.show && menuRef.value) {
    props.menu.recalcStyle(menuRef.value)
  }
})

useKeyDownStore().watch("Escape", () => props.menu.props.show, props.menu.close)


return (_ctx: any,_cache: any) => {
  const _component_v_context_menu = _resolveComponent("v-context-menu", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "grow" }, {
      default: _withCtx(() => [
        (props.menu.props.show)
          ? (_openBlock(), _createElementBlock("div", _mergeProps({
              key: 0,
              class: "context-menu"
            }, props.menu.props, _toHandlers(props.menu.hoverEmits, true), {
              ref_key: "menuRef",
              ref: menuRef
            }), [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["menu-item", [{ disabled: item.disabled || (!item.onClick && !item.children), hover: _unref(hoverElement) === item }, item.class]]),
                  onClick: ($event: any) => (onItemClick(item)),
                  onMouseenter: ($event: any) => (onItemHover($event, item))
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { size: 20 })),
                  _createTextVNode(" " + _toDisplayString(item.title) + " ", 1),
                  (!!item.children)
                    ? (_openBlock(), _createBlock(RightArrowIcon, {
                        key: 0,
                        style: {"height":"16px"},
                        class: "right-adornment"
                      }))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_1))
              }), 256))
            ], 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (props.menu.props.backdrop)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "backdrop-invisible",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (props.menu.close && props.menu.close(...args)), ["self"]))
        }))
      : _createCommentVNode("", true),
    (_unref(hasChildren))
      ? (_openBlock(), _createBlock(_component_v_context_menu, {
          key: 1,
          menu: _unref(childrenContextMenu),
          onItemclick: props.menu.close
        }, null, 8, ["menu", "onItemclick"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})